import React, { Component } from "react"
import { Modal, Button, Icon, Checkbox, Label, Loader, Image } from "semantic-ui-react"
import shop from "shop/shop"
import Price from "components/Price/Price"

class OneClickReorderModal extends Component {
  state = {
    loading: true,
    products: [],
  }

  async componentDidMount() {
    const { order } = this.props
    const resolved = await Promise.all(
      order.positions.map(async (position) => {
        const product = await shop.product(position.article_id)
        return {
          position,
          product,
          available: !!product,
          selected: !!product,
        }
      })
    )
    this.setState({ loading: false, products: resolved })
  }

  toggleProduct = (index) => {
    const products = [...this.state.products]
    products[index] = { ...products[index], selected: !products[index].selected }
    this.setState({ products })
  }

  toggleSelectAll = () => {
    const { products } = this.state
    const availableProducts = products.filter(p => p.available)
    const allSelected = availableProducts.every(p => p.selected)
    this.setState({
      products: products.map(p => p.available ? { ...p, selected: !allSelected } : p)
    })
  }

  handleAddToCart = () => {
    const { products } = this.state
    const splitMode = shop.config.plugin && shop.config.plugin.oneClickReorderSplit

    let addedCount = 0
    let unavailableCount = 0


    products.forEach(({ position, product, available, selected }) => {
      console.log("Adding to cart:", { position, product, available, selected })
      if (!available) {
        unavailableCount++
        return
      }
      if (splitMode && !selected) return
      product.price = position.price
      product.count = (position.count * position.unit_multi) / (product.extras && product.extras.veCount ? product.extras.veCount.value.value : product.unit_multi ? product.unit_multi : 1)
      console.log("Adding to cart: FINAL", { product })
      shop.cart.add(product)
      addedCount++
    })

    if (addedCount > 0) {
      shop.toast(translate("Produkte in den Warenkorb gelegt"), "success", false, "bottom")
    }
    if (unavailableCount > 0 && addedCount === 0) {
      shop.toast(translate("Keine Produkte verfügbar"), "info", false, "bottom")
    }

    this.props.onClose()
  }

  render() {
    const { open, onClose, order } = this.props
    const { loading, products } = this.state
    const splitMode = shop.config.plugin && shop.config.plugin.oneClickReorderSplit
    const baseUrl = process.env.BSHOP_BASE_URL || process.env.REACT_APP_API

    const selectedAvailable = products.filter(p => p.available && (splitMode ? p.selected : true))
    const selectedAvailableCount = selectedAvailable.length
    const selectedTotal = selectedAvailable.reduce((sum, { position }) => sum + (Number(position.sum) || 0), 0)
    const hasUnavailable = products.some(p => !p.available)
    const availableProducts = products.filter(p => p.available)
    const allSelected = availableProducts.length > 0 && availableProducts.every(p => p.selected)
    const someSelected = availableProducts.some(p => p.selected) && !allSelected

    return (
      <Modal centered={true} open={open} onClose={onClose} size="large" style={{ position: "fixed", top: "10%", }}>
        <Modal.Header style={{ backgroundColor: "#F8F7EC", borderBottom: "2px solid #D4AF37" }}>
          <span style={{ color: "#D4AF37" }}>
            <Icon name="redo alternate" />
          </span>
          {translate("Bestellung erneut aufgeben")} &nbsp;
          <span style={{ color: "#D4AF37" }}>#{order.map_id}</span>
        </Modal.Header>

        <Modal.Content scrolling style={{ padding: "0" }}>
          {loading ? (
            <div style={{ minHeight: "200px", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div style={{ textAlign: "center" }}>
                <Loader active inline="centered" size="large" />
                <p className="f5 pt3 black-60">{translate("Artikel werden geprüft...")}</p>
              </div>
            </div>
          ) : (
            <div>
              <div style={{ padding: "14px 24px", borderBottom: "1px solid #eee", backgroundColor: "#fafafa", display: "flex", alignItems: "center", gap: "14px" }}>
                {splitMode && (
                  <Checkbox
                    checked={allSelected}
                    indeterminate={someSelected}
                    onChange={this.toggleSelectAll}
                    label={<label style={{ fontWeight: 600, cursor: "pointer" }}>{allSelected ? translate("Alle abwählen") : translate("Alle auswählen")}</label>}
                  />
                )}
                {!splitMode && (
                  <p className="f5 fw5 black-60" style={{ margin: 0 }}>
                    {translate("Möchten Sie alle Artikel dieser Bestellung erneut in den Warenkorb legen?")}
                  </p>
                )}
              </div>

              <div style={{ maxHeight: "420px", overflowY: "auto" }}>
                {products.map(({ position, product, available, selected }, index) => (
                  <div
                    key={position.article_id + "_" + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "14px 24px",
                      borderBottom: "1px solid #f0f0f0",
                      backgroundColor: !available ? "#fafafa" : selected || !splitMode ? "#fff" : "#fff",
                      opacity: available ? 1 : 0.55,
                      transition: "background 0.15s",
                    }}
                  >
                    {splitMode && (
                      <div style={{ marginRight: "16px", flexShrink: 0 }}>
                        <Checkbox
                          checked={selected}
                          disabled={!available}
                          onChange={() => this.toggleProduct(index)}
                        />
                      </div>
                    )}
                    {console.log("position",position, baseUrl)}
                    <div style={{ flexShrink: 0, marginRight: "14px" }}>
                      {available ? (                      <img
                        src={`${baseUrl}/shop/rest/data/images/description/${position.article_nr}/1?size=small`}
                        style={{
                          width: "54px",
                          height: "54px",
                          objectFit: "contain",
                          borderRadius: "4px",
                          border: "1px solid #eee",
                          background: "#fff",
                          padding: "2px",
                        }}
                        alt=""
                      />) : (<img
                        src={"/image/placeholder.png"}
                        style={{
                          width: "54px",
                          height: "54px",
                          objectFit: "contain",
                          borderRadius: "4px",
                          border: "1px solid #eee",
                          background: "#fff",
                          padding: "2px",
                        }}
                        alt=""
                      />)}

                    </div>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div className="fw6 f5" style={{ marginBottom: "3px", whiteSpace: "normal" }}>
                        {console.log("position.desc", position)}
                        {position.desc && typeof position.desc === "object" ? position.desc.short_des : position.desc}
                      </div>
                      <div className="f6 black-60">
                        {translate("Art.-Nr.")} {position.article_nr || position.article_id}
                      </div>
                      <div className="f6 black-60">
                        {translate("Menge")}: <span className="fw6">{position.count}</span>
                      </div>
                    </div>

                    <div style={{ textAlign: "right", flexShrink: 0, marginLeft: "12px" }}>
                      <div className="fw6 f5">
                        <Price>{position.sum}</Price>
                      </div>
                      {!available && (
                        <div style={{ marginTop: "4px" }}>
                          <Label size="tiny" style={{ backgroundColor: "#fee2e2", color: "#dc2626", border: "1px solid #fca5a5" }}>
                            <Icon name="ban" style={{ marginRight: "3px" }} />
                            {translate("Nicht verfügbar")}
                          </Label>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {hasUnavailable && (
                <div style={{
                  margin: "0",
                  padding: "12px 24px",
                  backgroundColor: "#fffbeb",
                  borderTop: "1px solid #fde68a",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}>
                  <Icon name="warning sign" style={{ color: "#d97706", marginTop: "2px", flexShrink: 0 }} />
                  <span className="f6" style={{ color: "#92400e" }}>
                    {translate("Einige Artikel sind nicht mehr im Shop verfügbar und können nicht in den Warenkorb gelegt werden.")}
                  </span>
                </div>
              )}
            </div>
          )}
        </Modal.Content>

        <Modal.Actions style={{ backgroundColor: "#F8F7EC", borderTop: "1px solid #e0e0e0" }}>
          <Button basic onClick={onClose} style={{ borderRadius: "35px" }}>
            <Icon name="times" />
            {translate("Abbrechen")}
          </Button>
          <Button
            disabled={loading || selectedAvailableCount === 0}
            onClick={this.handleAddToCart}
            style={{
              borderRadius: "35px",
              height: "44px",
              backgroundColor: selectedAvailableCount === 0 ? undefined : "#D4AF37",
              color: selectedAvailableCount === 0 ? undefined : "#fff",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Icon name="shopping cart" style={{ margin: 0 }} />
            <span>
              {splitMode
                ? `${translate("Auswahl in den Warenkorb")} (${selectedAvailableCount})`
                : translate("Alle in den Warenkorb legen")}
            </span>
            {selectedAvailableCount > 0 && (
              <span style={{
                marginLeft: "6px",
                padding: "2px 10px",
                backgroundColor: "rgba(255,255,255,0.2)",
                borderRadius: "20px",
                fontWeight: 700,
                fontSize: "0.9em",
                whiteSpace: "nowrap",
              }}>
                <Price>{selectedTotal}</Price>
              </span>
            )}
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default OneClickReorderModal



// WEBPACK FOOTER //
// ./src/components/OneClickReorder/OneClickReorderModal.js